import React from 'react';
import { colors } from '../utils/colors';

const Subtitulo = props => (
	<div>
		<h3
			style={{
				fontSize: '1.2em',
				color: `${colors.black}`,
				padding: '1em 0.5em 1em 0.5em',
				maxWidth: '700px',
				margin: '0 auto',
				lineHeight: '1.45em'
			}}
		>
			{props.contenido}
		</h3>
	</div>
);

export default Subtitulo;



// WEBPACK FOOTER //
// ./src/components/SubtituloNegro.js